import { render, staticRenderFns } from "./AppNavigationSecondary.vue?vue&type=template&id=1415a6a4"
import script from "./AppNavigationSecondary.vue?vue&type=script&lang=js"
export * from "./AppNavigationSecondary.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationSecondary.vue?vue&type=style&index=0&id=1415a6a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports